// 검색 결과 항목(서버 /v1/address/search) ↔ 접수 폼이 쓰는 주소 값 변환, 검색어 하이라이트

export const KIND_LABEL = { road: '도로명', jibun: '지번', place: '건물' };

// 목록 첫 줄 — 건물·상호 검색이면 이름, 아니면 도로명(없으면 지번)
export function primaryText(item) {
  if (item.kind === 'place' && item.placeName) return item.placeName;
  return item.roadAddress || item.jibunAddress || '';
}

// 목록 둘째 줄 — 첫 줄에 쓰지 않은 나머지 주소와 건물명
export function secondaryText(item) {
  const parts = [];
  if (item.kind === 'place') {
    parts.push(item.roadAddress || item.jibunAddress);
  } else if (item.kind === 'road') {
    if (item.jibunAddress) parts.push('지번 ' + item.jibunAddress);
    if (item.buildingName) parts.push(item.buildingName);
  } else if (item.roadAddress) {
    parts.push('도로명 ' + item.roadAddress);
  }
  return parts.filter(Boolean).join(' · ');
}

// 롯데홈쇼핑 접수와 같은 표기 — '지번주소 (도로명주소)'. 지번이 없으면 도로명만.
// 접수 폼·인성 전송·운임 계산이 이 문자열 앞부분(지번)에서 시·구·동을 읽는다.
export function toSelection(item) {
  const building = item.buildingName || item.placeName || '';
  const jibun = item.jibunAddress || '';
  const road = item.roadAddress || '';
  const address = jibun
    ? jibun + (road && road !== jibun ? ` (${road})` : '')
    : road;
  return {
    address,
    bcode: item.bcode || '',
    zonecode: item.zonecode || '',
    roadAddress: item.roadAddress || '',
    jibunAddress: item.jibunAddress || '',
    buildingName: building,
    bname: item.bname || '',
    x: item.x || '',
    y: item.y || '',
  };
}

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// 검색어 토큰이 들어간 부분을 { text, hit } 조각으로 나눈다 — 하이라이트 렌더링용
export function highlight(text, query) {
  const s = String(text || '');
  const tokens = String(query || '').trim().split(/\s+/).filter(Boolean);
  if (!s || !tokens.length) return [{ text: s, hit: false }];
  const re = new RegExp('(' + tokens.map(escapeRe).join('|') + ')', 'gi');
  const lower = tokens.map((t) => t.toLowerCase());
  return s
    .split(re)
    .filter((p) => p !== '')
    .map((p) => ({ text: p, hit: lower.includes(p.toLowerCase()) }));
}
